export enum IClientType {
	NOTIFICATIONS="NOTIFICATIONS",
	MARKETING="MARKETING",
}
